var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({
      position: 'absolute',
      top: _vm.mmToEm(_vm.doubleRack ? (_vm.isUpper ? 25 : -25) : 0)
    })},[_c('div',{style:({
        position: 'absolute',
        top: 0,
        width: _vm.mmToEm(_vm.selectedUprights.width),
        height: _vm.mmToEm(55),
        background:
          _vm.gableColor,
        zIndex: 1000
      })}),_c('div',{style:({
        position: 'absolute',
        top: _vm.mmToEm(55),
        left: _vm.mmToEm(_vm.selectedUprights.width / 2 - 10),
        width: _vm.mmToEm(20),
        height: _vm.mmToEm(1100 - 110 + (_vm.doubleRack && _vm.isUpper ? 400 : 0)),
        background:
          _vm.gableColor,
        zIndex: 1000
      })}),_c('div',{style:({
        position: 'absolute',
        top: _vm.mmToEm(1100 - 55),
        width: _vm.mmToEm(_vm.selectedUprights.width),
        height: _vm.mmToEm(55),
        background:
          _vm.gableColor,
        zIndex: 1000
      })}),(_vm.isRightmost)?[_c('div',{style:({
          left: _vm.mmToEm(_vm.sector.beam.length + _vm.selectedUprights.width),
          position: 'absolute',
          top: 0,
          width: _vm.mmToEm(_vm.selectedUprights.width),
          height: _vm.mmToEm(55),
          background:
            _vm.gableColor,
          zIndex: 1000
        })}),_c('div',{style:({
          position: 'absolute',
          top: _vm.mmToEm(55),
          left: _vm.mmToEm(
            _vm.sector.beam.length +
              _vm.selectedUprights.width +
              (_vm.selectedUprights.width / 2 - 10)
          ),
          width: _vm.mmToEm(20),
          height: _vm.mmToEm(1100 - 110 + (_vm.doubleRack && _vm.isUpper ? 400 : 0)),
          background:
            _vm.gableColor,
          zIndex: 1000
        })}),_c('div',{style:({
          position: 'absolute',
          left: _vm.mmToEm(_vm.sector.beam.length + _vm.selectedUprights.width),
          top: _vm.mmToEm(1100 - 55),
          width: _vm.mmToEm(_vm.selectedUprights.width),
          height: _vm.mmToEm(55),
          background:
            _vm.gableColor,
          zIndex: 1000
        })})]:_vm._e()],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.includeImpactProtectors && _vm.isLeftmost),expression:"includeImpactProtectors && isLeftmost"}],style:({
      position: 'absolute',
      boxSizing: 'border-box',
      left: _vm.mmToEm(-175),
      top: _vm.mmToEm(0),
      zIndex: 1000
    })},[(!_vm.doubleRack || (_vm.doubleRack && _vm.isUpper))?_c('div',{style:({
        position: 'absolute',
        height: _vm.mmToEm(75),
        width: _vm.mmToEm(75),
        top: _vm.mmToEm(0),
        background:
          _vm.impactProtectorColor
      })}):_vm._e(),(!_vm.doubleRack || (_vm.doubleRack && !_vm.isUpper))?_c('div',{style:({
        position: 'absolute',
        height: _vm.mmToEm(75),
        width: _vm.mmToEm(75),
        top: _vm.mmToEm(1100 - 75),
        background:
          _vm.impactProtectorColor
      })}):_vm._e(),_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(5),
        height: _vm.mmToEm(950 + (_vm.doubleRack && _vm.isUpper ? 450 : 0)),
        width: _vm.mmToEm(65),
        top: _vm.mmToEm(75),
        background:
          _vm.gableColor
      })}),_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(70),
        height: _vm.mmToEm(75),
        width: _vm.mmToEm(85),
        top: _vm.mmToEm(150),
        background:
          _vm.gableColor
      })}),_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(70),
        height: _vm.mmToEm(75),
        width: _vm.mmToEm(85),
        top: _vm.mmToEm(875),
        background:
          _vm.gableColor
      })})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.includeImpactProtectors && _vm.isRightmost),expression:"includeImpactProtectors && isRightmost"}],style:({
      position: 'absolute',
      boxSizing: 'border-box',
      left: _vm.mmToEm(_vm.sector.beam.length + _vm.selectedUprights.width + 145),
      top: _vm.mmToEm(0),
      zIndex: 1000
    })},[(!_vm.doubleRack || (_vm.doubleRack && _vm.isUpper))?_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(70),
        height: _vm.mmToEm(75),
        width: _vm.mmToEm(75),
        top: _vm.mmToEm(0),
        background:
          _vm.impactProtectorColor
      })}):_vm._e(),(!_vm.doubleRack || (_vm.doubleRack && !_vm.isUpper))?_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(70),
        height: _vm.mmToEm(75),
        width: _vm.mmToEm(75),
        top: _vm.mmToEm(1100 - 75),
        background:
          _vm.impactProtectorColor
      })}):_vm._e(),_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(75),
        height: _vm.mmToEm(950 + (_vm.doubleRack && _vm.isUpper ? 450 : 0)),
        width: _vm.mmToEm(65),
        top: _vm.mmToEm(75),
        background:
          _vm.gableColor
      })}),_c('div',{style:({
        position: 'absolute',
        height: _vm.mmToEm(75),
        width: _vm.mmToEm(85),
        top: _vm.mmToEm(150),
        background:
          _vm.gableColor
      })}),_c('div',{style:({
        position: 'absolute',
        height: _vm.mmToEm(75),
        width: _vm.mmToEm(85),
        top: _vm.mmToEm(875),
        background:
          _vm.gableColor
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }